import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
// import { MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { AfterViewInit, Directive, ViewChild } from '@angular/core';
import { ExamDivisionDataComponent } from '../exam-division-data/exam-division-data.component';
import { ExamAggregateComponent } from '../exam-aggregate/exam-aggregate.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExamSemesterDataComponent } from '../exam-semester-data/exam-semester-data.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DefineGradeComponent } from '../define-grade/define-grade.component';

@Component({
  selector: 'app-exam-dialog-box',
  templateUrl: './exam-dialog-box.component.html',
  styleUrls: ['./exam-dialog-box.component.scss']
})
export class ExamDialogBoxComponent implements OnInit, AfterViewInit {
  ExamForm: FormGroup;
  marksGrid: FormArray;
  countofrowmarksGrid = 0;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  resetButton = false;
  ExamSemesterDisabled = true;
  ExamAggregateDisabled = true;
  SemesterDisabled = true;
  DefGrdDisabled = false;
  SemTab = false;
  ExamAggregateTab=false;
  ExamDivisionDisabled = true;
  deleteButton = false;
  Practical = false;
  RadioButn : boolean;
  DefGrd = false;
  hideForOneSrNo = true;
  examList: any;
  ExamFormArray = [];
  exam: string;
  list;
  isDiv = false;
  examform: any;
  ExamSearchForm;
  APIService: any;
  CoCodeList: any;
  filteredListCoCode: any;
  CourseList: any;
  filteredListCourse: any;
  filteredListExam: any;
  dialogRef: MatDialogRef<any>;
  dropdowndisable = false;
  autoserialnumber = 0;
  coursePattern : any;
  coursePattern1 : any;
  clrexam = 0;
  subTotalList: any;
  filteredSubTotalList: any;
  name: any;
  desLabel: string = "";
  markList: any;
  filteredListOfEmEval: any;
  evaluationList: any;
  filteredListOfMark: any;
  codeTypeList: any;
  filteredCodeType: any;
  examList2: any;
  elgbRuleList: any;
  selectedIndex: number = 0;
  filteredElgbRuleList: any;
  deleteReadOnly = false;
  Read = false;
  ReadOnly = false;
  emCodeRead = false;
  ReadOnlyCo = false;
  subtotalList: any;
  filteredsubtotalList: any;
  payload: any;
  classRuleList: any;
  filteredListClass: any;
  value: any;
  failvalue: any = [];
  fail2: any[];
  fail1: any;
  DefGradesBoolean = true;
  userPermission: any;
  utp: any;
  ExCreate = true;
  ExUpdate = true;
  ExDelete = true;
  ExamDivisionView = true;
ExamAggrigateView = true;
ExamSemesterView = true;
  selectedRadio: any;
  inputValue: any;
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private dialogRef1: MatDialogRef<ExamDialogBoxComponent>,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.APIService = environment.serviceUrl;
  }
  @ViewChild(ExamDivisionDataComponent, { static: false })
  private ExamDivision: ExamDivisionDataComponent;
  @ViewChild(ExamAggregateComponent, { static: false })
  private ExamAggregate: ExamAggregateComponent;
  @ViewChild(ExamSemesterDataComponent, { static: false })
  private Semester: ExamSemesterDataComponent;
  @ViewChild(DefineGradeComponent, {static: false})
  private DefineGrade: DefineGradeComponent;

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Exam' && element.PCreate == false) {
          this.ExCreate = false;
        }
        if (element.PageName == 'Exam' && element.PUpdate == false) {
          this.ExUpdate = false;
        }
        if (element.PageName == 'Exam' && element.PDelete == false) {
          this.ExDelete = false;
        }
        if(element.PageName == 'Exam-Division' && element.PView == false)
        {
            this.ExamDivisionView = false;  
        } 
        if(element.PageName == 'Exam-Aggrigate' && element.PView == false)
        {
            this.ExamAggrigateView = false;  
        } 
        if(element.PageName == 'Exam-Semester' && element.PView == false)
        {
            this.ExamSemesterView = false;  
        } 
      });
    }
    window.scroll(0, 0);
    this.desLabel = '';
    let id = '';
    this.hideForOneSrNo = true;
    this.submitButton = true;
    this.editButton = false;
    this.dropdowndisable = false;
    this.isDiv = false;
    this.autoserialnumber = 0;
    this.clrexam = 0;
    this.list = true;
    this.DefGrd = false;
    this.SemesterDisabled = true;
    this.DefGrdDisabled = false;
    this.ExamForm = this.fb.group({
      EmId: new FormControl(this.data.selected['EmId'], [Validators.pattern('^[0-9]*$')]),
      EmCoCode: new FormControl('', [Validators.required,]),
      EmSrNo: new FormControl(this.autoserialnumber, [Validators.pattern('^[0-9]*$'),]),
      EmCode: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-z0-9- &\\s]*$"),]),
      EmName: new FormControl('', [Validators.required]),
      EmShName: new FormControl('', [Validators.required]),
      EmStreams: new FormControl(this.data.selected['EmStreams']),
      EmClrSrNo: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmATKTSub: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmElgblCd: new FormControl(''),
      EmSpFlag: new FormControl(''),
      EmLedger: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmMarkList: new FormControl(this.data.selected['EmMarkList'], [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmLatEntry: new FormControl(this.data.selected['EmLatEntry']),
      EmRejImpr: new FormControl(this.data.selected['EmRejImpr'], [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmEval: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmTotSub: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmMaxTot: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      // 22.02.2024 
      // EmPassPC: new FormControl('', [Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]*)?))$'), Validators.max(100),]),
      EmVal: new FormControl(this.data.selected['EmVal'], [Validators.pattern('^[0-9]*$')]),
      EmValDev: new FormControl(this.data.selected['EmValDev'], [Validators.pattern('^[0-9]*$')]),
      EmDiv: new FormControl(this.data.selected['EmDiv']),
      EmCompart: new FormControl(''),
      EmConv: new FormControl(this.data.selected['EmConv']),
      EmDivFirstAtt: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$'),]),
      EmDivFirstMrk: new FormControl(''),
      EmColg: new FormControl(''),
      EmGrps: new FormControl(''),
      EmSubTot: new FormControl(''),
      EmMinCr: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmMaxCr: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmExmSuppl: new FormControl(''),
      EmExmQ: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmMarksD: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmDebar: new FormControl(''),
      EmDebarNo: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmDebarType: new FormControl(''),
      FailInValue: new FormControl(''),
      marksGrid: new FormArray([]),
    });
    this.getExamAllData();
    this.getEvaluation();
    this.fetchCourseCode();
    this.fetchMarklist();
    this.fetchSubTotal();
    this.fetchCodeType(id);
    this.fetchElgbRule();
    this.fetchUseSubTotal();
    this.getclassRule();
    this.openData();
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
      this.loadExamList2(this.data.selected)
      // this.selectExam('true', this.data.selected);
    } else if (this.data.key == "Delete") {
      this.prepopulationForDelete(this.data.selected);
      this.loadExamList2(this.data.selected)
    } else {
      // alert(this.data.key)
    }
    
  }

  openData() {
    this.desLabel = " ";
    this.list = false;
    this.examList = [];
    this.dropdowndisable = false;
    this.submitButton = true;
    this.editButton = false;
    this.resetButton = true;
    this.deleteButton = false;
    this.deleteReadOnly = false;
    this.Read = false;
    this.ReadOnly = false;
    this.emCodeRead = false
    this.ReadOnlyCo = false;
    this.isDiv = false;
    this.ExamAggregateDisabled = true;
    this.ExamDivisionDisabled = true;
    this.ExamForm.controls.EmSrNo.setValue('');
    this.ExamForm.controls.EmId.setValue('');
    // sessionStorage.setItem('EmId', this.ExamForm.controls.EmId.value);
    this.prev();
    this.loadsettingspage();
  }

  ngAfterViewInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Exam' && element.PCreate == false) {
          this.ExCreate = false;
        }
        if (element.PageName == 'Exam' && element.PUpdate == false) {
          this.ExUpdate = false;
        }
        if (element.PageName == 'Exam' && element.PDelete == false) {
          this.ExDelete = false;
        }
        if(element.PageName == 'Exam-Division' && element.PView == false)
        {
            this.ExamDivisionView = false;  
        } 
        if(element.PageName == 'Exam-Aggrigate' && element.PView == false)
        {
            this.ExamAggrigateView = false;  
        } 
        if(element.PageName == 'Exam-Semester' && element.PView == false)
        {
            this.ExamSemesterView = false;  
        } 
      });
    }
    window.scroll(0, 0);
    this.desLabel = '';
    let id = '';
    this.hideForOneSrNo = true;
    this.submitButton = true;
    this.editButton = false;
    this.dropdowndisable = false;
    this.isDiv = false;
    this.autoserialnumber = 0;
    this.clrexam = 0;
    this.list = true;
    this.DefGrd = false;
    this.SemesterDisabled = true;
    this.DefGrdDisabled = false;
    this.ExamForm = this.fb.group({
      EmId: new FormControl(this.data.selected['EmId'], [Validators.pattern('^[0-9]*$')]),
      EmCoCode: new FormControl('', [Validators.required,]),
      EmSrNo: new FormControl(this.autoserialnumber, [Validators.pattern('^[0-9]*$'),]),
      EmCode: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-z0-9- &\\s]*$"),]),
      EmName: new FormControl('', [Validators.required]),
      EmShName: new FormControl('', [Validators.required]),
      EmStreams: new FormControl(this.data.selected['EmStreams']),
      EmClrSrNo: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmATKTSub: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmElgblCd: new FormControl(''),
      EmSpFlag: new FormControl(''),
      EmLedger: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmMarkList: new FormControl(this.data.selected['EmMarkList'], [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmLatEntry: new FormControl(this.data.selected['EmLatEntry']),
      EmRejImpr: new FormControl(this.data.selected['EmRejImpr'], [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmEval: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmTotSub: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmMaxTot: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      // 22.02.2024 
      // EmPassPC: new FormControl('', [Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]*)?))$'), Validators.max(100),]),
      EmVal: new FormControl(this.data.selected['EmVal'], [Validators.pattern('^[0-9]*$')]),
      EmValDev: new FormControl(this.data.selected['EmValDev'], [Validators.pattern('^[0-9]*$')]),
      EmDiv: new FormControl(this.data.selected['EmDiv']),
      EmCompart: new FormControl(''),
      EmConv: new FormControl(this.data.selected['EmConv']),
      EmDivFirstAtt: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$'),]),
      EmDivFirstMrk: new FormControl(''),
      EmColg: new FormControl(''),
      EmGrps: new FormControl(''),
      EmSubTot: new FormControl(''),
      EmMinCr: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmMaxCr: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmExmSuppl: new FormControl(''),
      EmExmQ: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmMarksD: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmDebar: new FormControl(''),
      EmDebarNo: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmDebarType: new FormControl(''),
      FailInValue: new FormControl(''),
      marksGrid: new FormArray([]),
    });
    this.getExamAllData();
    this.getEvaluation();
    this.fetchCourseCode();
    this.fetchMarklist();
    this.fetchSubTotal();
    this.fetchCodeType(id);
    this.fetchElgbRule();
    this.fetchUseSubTotal();
    this.getclassRule();
    this.openData();
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
      this.loadExamList2(this.data.selected)
      // this.selectExam('true', this.data.selected);
    } else if (this.data.key == "Delete") {
      this.prepopulationForDelete(this.data.selected);
      this.loadExamList2(this.data.selected)
    } else {
      // alert(this.data.key)
    }
    
    // let e = '';
    // let k = '';
    // this.loadsettingspage();
    // this.prepopulatedatapage(this.data.selected)
    // this.editdata('true', this.data.selected)
  }

  resetForm() {
    this.desLabel = '';
    this.submitButton = true;
    this.editButton = false;
    this.dropdowndisable = false;
    this.DefGrd = false;
    this.isDiv = false;
    this.autoserialnumber = 0;
    this.clrexam = 0;
    // this.list = true;
    this.ExamForm = this.fb.group({
      EmId: new FormControl(this.data.selected['EmId'], [Validators.pattern('^[0-9]*$')]),
      EmCoCode: new FormControl('', [Validators.required,]),
      EmSrNo: new FormControl(this.autoserialnumber, [Validators.pattern('^[0-9]*$'),]),
      EmCode: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-z0-9- &\\s]*$"),]),
      EmName: new FormControl('', [Validators.required]),
      EmShName: new FormControl('', [Validators.required]),
      EmStreams: new FormControl(this.data.selected['EmStreams']),
      EmClrSrNo: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmATKTSub: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmElgblCd: new FormControl(''),
      EmSpFlag: new FormControl(''),
      EmLedger: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmMarkList: new FormControl(this.data.selected['EmMarkList'], [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmLatEntry: new FormControl(this.data.selected['EmLatEntry']),
      EmRejImpr: new FormControl(this.data.selected['EmRejImpr'], [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmEval: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmTotSub: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmMaxTot: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      // EmPassPC: new FormControl('', [Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]*)?))$'), Validators.max(100),]),
      EmVal: new FormControl(this.data.selected['EmVal'], [Validators.pattern('^[0-9]*$')]),
      EmValDev: new FormControl(this.data.selected['EmValDev'], [Validators.pattern('^[0-9]*$')]),
      EmDiv: new FormControl(this.data.selected['EmDiv']),
      EmCompart: new FormControl(''),
      EmConv: new FormControl(this.data.selected['EmConv']),
      EmDivFirstAtt: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$'),]),
      EmDivFirstMrk: new FormControl(''),
      EmColg: new FormControl(''),
      EmGrps: new FormControl(''),
      EmSubTot: new FormControl(''),
      EmMinCr: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmMaxCr: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmExmSuppl: new FormControl(''),
      EmExmQ: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmMarksD: new FormControl('', [Validators.pattern('^[a-zA-Z0-9]*$')]),
      EmDebar: new FormControl(''),
      EmDebarNo: new FormControl('', [Validators.pattern('^[0-9]*$')]),
      EmDebarType: new FormControl(''),
      FailInValue: new FormControl(''),
      marksGrid: new FormArray([]),
    });
    this.getExamAllData();
  }

  getmarksGridControls() {
    return (this.ExamForm.get('marksGrid') as FormArray).controls;
  }

  getExamData(e) {
    const payload = {};
    payload['EmCoCode'] = e.EmCoCode;
    payload['EmId'] = e.EmId;
    this.autoserialnumber = 0;
    this.clrexam = 0;
    this.umsService.getExam(payload).subscribe((res) => {
      this.examList = res.data;
      this.autoserialnumber = res.data.length + 1;
      this.clrexam = this.autoserialnumber - 1;
      if(this.autoserialnumber == 1 && this.coursePattern == 'Y'){
        this.hideForOneSrNo = false
      }
      else if(this.autoserialnumber == 1 && this.coursePattern == 'S'){
        this.hideForOneSrNo = false
      }
      else if(this.autoserialnumber == 2 && this.coursePattern == 'S'){
        this.hideForOneSrNo = false
      }
      else if(this.autoserialnumber == 4 && this.coursePattern == 'S'){
        this.hideForOneSrNo = false
      }
      else if(this.autoserialnumber == 6 && this.coursePattern == 'S'){
        this.hideForOneSrNo = false
      }
      else if(this.autoserialnumber == 8 && this.coursePattern == 'S'){
        this.hideForOneSrNo = false
      }
      else if(this.autoserialnumber == 1 && this.coursePattern == ''){
        this.hideForOneSrNo = false
      }
      else if(this.autoserialnumber == 2 && this.coursePattern == ''){
        this.hideForOneSrNo = false
      }
      else if(this.autoserialnumber == 4 && this.coursePattern == ''){
        this.hideForOneSrNo = false
      }
      else if(this.autoserialnumber == 6 && this.coursePattern == ''){
        this.hideForOneSrNo = false
      }
      else if(this.autoserialnumber == 8 && this.coursePattern == ''){
        this.hideForOneSrNo = false
      }
      else{
        this.hideForOneSrNo = true
      }
      this.ExamForm.controls.EmSrNo.setValue(this.autoserialnumber);
      this.ExamForm.controls.EmClrSrNo.setValue(this.clrexam);
      if (this.examList[0]) {
        this.editdata('true', this.examList[0]);
      }
    });
  }

  loadExamList2(e) {
    this.spinner.show();
    const payload = {};
    payload['EmCoCode'] = e.EmCoCode;
    payload['EmId'] = '';
    this.examList2 = [];
    this.umsService.getExam(payload).subscribe(
      (res) => {
        this.spinner.hide();
        this.examList2 = res.data;
        if (res.data.length > 0) {
          this.isDiv = true;
        } else {
          this.isDiv = false;
        }
      },
      (ERROR: HttpErrorResponse) => {

      }
    );
  }

  getExamDataNoPrepoluation2(e) {
    const payload = {};
    payload['EmCoCode'] = e.EmCoCode;
    payload['EmId'] = '';
    this.examList2 = [];
    this.autoserialnumber = 0;
    this.clrexam = 0;
    this.umsService.getExam(payload).subscribe(
      (res) => {
        this.examList2 = res.data;
        this.autoserialnumber = this.examList2.length + 1;
        this.clrexam = this.autoserialnumber - 1;
        if(this.autoserialnumber == 1 && this.coursePattern == 'Y'){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 1 && this.coursePattern == 'S'){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 2 && this.coursePattern == 'S'){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 4 && this.coursePattern == 'S'){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 6 && this.coursePattern == 'S'){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 8 && this.coursePattern == 'S'){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 1 && this.coursePattern == ''){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 2 && this.coursePattern == ''){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 4 && this.coursePattern == ''){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 6 && this.coursePattern == ''){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 8 && this.coursePattern == ''){
          this.hideForOneSrNo = false
        }
        else{
          this.hideForOneSrNo = true
        }
        this.ExamForm.patchValue({
          EmSrNo: this.autoserialnumber,
          EmClrSrNo: this.clrexam,
        });
      },
      (ERROR: HttpErrorResponse) => {
        this.ExamForm.patchValue({
          EmSrNo: 1,
        });
      }
    );
  }

  getExamDataNoPrepoluation(e) {
    this.autoserialnumber = 0;
    this.clrexam = 0;
    const payload = {};
    if (e.EmCoCode) {
      payload['EmCoCode'] = e.EmCoCode;
    } else {
      payload['EmCoCode'] = e.CoCode;
    }
    payload['EmId'] = '';
    this.examList2 = [];
    this.umsService.getExam(payload).subscribe(
      (res) => {
        this.examList2 = res.data;
        this.autoserialnumber = this.examList2.length + 1;
        this.clrexam = this.autoserialnumber - 1;
        if(this.autoserialnumber == 1 && this.coursePattern == 'Y'){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 1 && this.coursePattern == 'S'){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 2 && this.coursePattern == 'S'){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 4 && this.coursePattern == 'S'){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 6 && this.coursePattern == 'S'){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 8 && this.coursePattern == 'S'){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 1 && this.coursePattern == ''){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 2 && this.coursePattern == ''){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 4 && this.coursePattern == ''){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 6 && this.coursePattern == ''){
          this.hideForOneSrNo = false
        }
        else if(this.autoserialnumber == 8 && this.coursePattern == ''){
          this.hideForOneSrNo = false
        }
        else{
          this.hideForOneSrNo = true
        }
        this.ExamForm.patchValue({
          EmSrNo: this.autoserialnumber,
          EmClrSrNo: this.clrexam,
        });
        if (res.message == "No Data Found") {
          this.isDiv = false;
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.ExamForm.patchValue({
          EmSrNo: 1,
        });
      }
    );
  }

  getExamDataNoPrepoluationUpdate(e) {
    this.autoserialnumber = 0;
    this.clrexam = 0;
    const payload = {};
    if (e.EmCoCode) {
      payload['EmCoCode'] = e.EmCoCode;
    } else {
      payload['EmCoCode'] = e.CoCode;
    }
    payload['EmId'] = '';
    this.examList2 = [];
    this.umsService.getExam(payload).subscribe(
      (res) => {
        this.examList2 = res.data;
        // this.autoserialnumber = this.examList2.length + 1;
        // this.clrexam = this.autoserialnumber - 1;
        // this.ExamForm.patchValue({
        //   EmSrNo: this.autoserialnumber,
        //   EmClrSrNo: this.clrexam,
        // });
        if (res.message == "No Data Found") {
          this.isDiv = false;
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.ExamForm.patchValue({
          EmSrNo: 1,
        });
      }
    );
  }

  getExamAllData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getExam(payload).subscribe((res) => {
      this.examList = res.data;
      this.desLabel = " ";
      this.spinner.hide();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }


  fetchCourseCode() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCourse(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      } else {
        this.spinner.hide();
      }
    });
  }

  getCourse(e) {
    this.coursePattern = e.CoPattern;
    this.ExamForm.controls.EmEval.setValue(e.CoEval)
    if(e.CoEval == "GPA"){
      this.DefGrd = true;
      this.DefGrdDisabled = true;
    }
    else{
      this.DefGrd = false;
    }
  }

  fetchCourseCode2(code) {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = code;
    this.umsService.getCourse(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.CourseList = res.data;
        this.coursePattern1 = res.data[0].CoPattern;
        sessionStorage.setItem('CoPattern', res.data[0].CoPattern);
      } else {
        this.spinner.hide()
      }
    });
  }

  fetchExamData() {
    this.spinner.show()
    const payload = {};
    this.umsService.getExam(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      } else {
        this.spinner.hide()
      }
    });
  }

  examSort(e) {
    this.spinner.show()
    const payload = {};
    payload['EmCoCode'] = e.EmCoCode;
    payload['EmId'] = e.EmId;
    this.umsService.getExam(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        this.examList = res.data;
      }else{
        this.spinner.hide()
      }
     
    });
  }

  prepopulation(e) {
    this.SemesterDisabled = false;
    this.prepopulatedatapage(e);
    // this.labelClick(e.EmCoCode);
    this.ReadOnly = true;
    this.emCodeRead = true;
    this.ReadOnlyCo = true;
    this.emCodeRead =true;
    this.spinner.show();
    const payload = {};
    payload['EmCoCode'] = e.EmCoCode;
    payload['EmId'] = e.EmId;
    sessionStorage.setItem('EmSubTot', '');
    this.umsService.getExam(payload).subscribe((res) => {
      this.spinner.hide();
      const data = res.data[0];
      if (data.EmSpFlag && data.EmSpFlag.length > 1) {
        // Split the value into radio and input parts
        const radioValue = data.EmSpFlag.charAt(0); // 'S' or 'P'
        this.inputValue = data.EmSpFlag.substring(1); // '3' or '4'

        // Set the radio button value based on the first character
        this.selectedRadio = radioValue;

        // Set the input box value (the numeric part)
    }
      let data1 = {};
      if (res.spRule.length == 1) {
        let fail = []
        fail.push(res.spRule[0]['SrNoMarks']);
        data1['SrNoMarks'] = fail;
      } else {
        data1['SrNoMarks'] = 0;
      }
      if (data.EmElgblCd == 'NA') {
        data1['SrNoMarks'] = 0
      }
      if (res.status) {
        this.editButton = true;
        this.submitButton = false;
        this.deleteButton = false;
        this.resetButton = false;
        this.emCodeRead = true;
        this.isDiv = true;
        let EmColg = false;
        if (data.EmColg == 1) {
          EmColg = true;
        } else {
          EmColg = false;
        }
        let EmGrps = false;
        if (data.EmGrps == 1) {
          EmGrps = true;
        } else {
          EmGrps = false;
        }
        let EmDivFirstAtt = false;

        if (data.EmDivFirstAtt == 1) {
          EmDivFirstAtt = true;
        } else {
          EmDivFirstAtt = false;
        }
        let EmMarksD = false;

        if (data.EmMarksD == 1) {
          EmMarksD = true;
        } else {
          EmMarksD = false;
        }
        if(data.EmEval == 'GPA'){
          this.DefGrd = true;
          this.DefGrdDisabled = false;
        }
        else{
          this.DefGrd = false;
        }
        this.fetchCourseCode2(data.EmCoCode)
        this.coursePattern1 = sessionStorage.getItem('CoPattern')
         if(data.EmSrNo == 1 && this.coursePattern1 == 'Y'){
        this.hideForOneSrNo = false
      }
      else if(data.EmSrNo == 1 && this.coursePattern1 == 'S'){
        this.hideForOneSrNo = false
      }
      else if(data.EmSrNo == 2 && this.coursePattern1 == 'S'){
        this.hideForOneSrNo = false
      }
      else if(data.EmSrNo == 4 && this.coursePattern1 == 'S'){
        this.hideForOneSrNo = false
      }
      else if(data.EmSrNo == 6 && this.coursePattern1 == 'S'){
        this.hideForOneSrNo = false
      }
      else if(data.EmSrNo == 8 && this.coursePattern1 == 'S'){
        this.hideForOneSrNo = false
      }
      else if(data.EmSrNo == 1 && this.coursePattern1 == ''){
        this.hideForOneSrNo = false
      }
      else if(data.EmSrNo == 2 && this.coursePattern1 == ''){
        this.hideForOneSrNo = false
      }
      else if(data.EmSrNo == 4 && this.coursePattern1 == ''){
        this.hideForOneSrNo = false
      }
      else if(data.EmSrNo == 6 && this.coursePattern1 == ''){
        this.hideForOneSrNo = false
      }
      else if(data.EmSrNo == 8 && this.coursePattern1 == ''){
        this.hideForOneSrNo = false
      }
      else{
        this.hideForOneSrNo = true
      }
      
        this.ExamForm = this.fb.group({
          EmId: new FormControl(data.EmId, [Validators.pattern('^[0-9]*$')]),
          EmCoCode: new FormControl(data.EmCoCode, [Validators.required,]),
          EmSrNo: new FormControl(data.EmSrNo, [Validators.pattern('^[0-9]*$'),]),
          EmCode: new FormControl(data.EmCode, [Validators.required, Validators.pattern("^[a-zA-z0-9- &\\s]*$"),]),
          EmName: new FormControl(data.EmName, [Validators.required]),
          EmCompart: new FormControl(this.inputValue),
          EmShName: new FormControl(data.EmShName, [Validators.required]),
          EmStreams: new FormControl(data.EmStreams),
          EmClrSrNo: new FormControl(data.EmSrNo - 1, [Validators.pattern('^[0-9]*$'),]),
          EmATKTSub: new FormControl(data.EmATKTSub, [Validators.pattern('^[0-9]*$'),]),
          EmElgblCd: new FormControl(data.EmElgblCd),
          EmLedger: new FormControl(data.EmLedger, [Validators.pattern('^[a-zA-Z0-9]*$'),]),
          EmMarkList: new FormControl(data.EmMarkList, [Validators.pattern('^[a-zA-Z0-9]*$'),]),
          EmLatEntry: new FormControl(data.EmLatEntry),
          EmRejImpr: new FormControl(data.EmRejImpr, [Validators.pattern('^[a-zA-Z0-9]*$'),]),
          EmEval: new FormControl(data.EmEval, [Validators.pattern('^[a-zA-Z0-9]*$'),]),
          EmTotSub: new FormControl(data.EmTotSub, [Validators.pattern('^[0-9]*$'),]),
          EmMaxTot: new FormControl(data.EmMaxTot, [Validators.pattern('^[0-9]*$'),]),
          // EmPassPC: new FormControl(data.EmPassPC, [Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]*)?))$'), Validators.max(100),]),
          EmVal: new FormControl(data.EmVal, [Validators.pattern('^[0-9]*$')]),
          EmValDev: new FormControl(data.EmValDev, [Validators.pattern('^[0-9]*$'),]),
          EmDiv: new FormControl(data.EmDiv),
          EmConv: new FormControl(data.EmConv),
          EmDivFirstAtt: new FormControl(EmDivFirstAtt),
          EmDivFirstMrk: new FormControl(data.EmDivFirstMrk),
          EmColg: new FormControl(EmColg),
          EmGrps: new FormControl(EmGrps),
          EmSpFlag: new FormControl(data.EmSpFlag),
          EmSubTot: new FormControl(data.EmSubTot),
          EmMinCr: new FormControl(data.EmMinCr, [Validators.pattern('^[0-9]*$'),]),
          EmMaxCr: new FormControl(data.EmMaxCr, [Validators.pattern('^[0-9]*$'),]),
          EmExmSuppl: new FormControl(data.EmExmSuppl),
          EmExmQ: new FormControl(data.EmExmQ, [Validators.pattern('^[a-zA-Z0-9]*$'),]),
          EmMarksD: new FormControl(EmMarksD),
          EmDebar: new FormControl(data.EmDebar),
          EmDebarNo: new FormControl(data.EmDebarNo, [Validators.pattern('^[0-9]*$'),]),
          EmDebarType: new FormControl(data.EmDebarType),
          FailInValue: new FormControl(data1['SrNoMarks']),
          marksGrid: new FormArray([]),
        });
         if (res.spRule.length == 1) {
           this.getValue1(data1['SrNoMarks'])
         }
        sessionStorage.setItem('EmName', e.EmName);
        sessionStorage.setItem('EmId', e.EmId);
        sessionStorage.setItem('EmCoCode', e.EmCoCode);
        sessionStorage.setItem('EmDiv', e.EmDiv);
        sessionStorage.setItem('EmElgblCd', e.EmElgblCd);
        sessionStorage.setItem('EmSubTot', e.EmSubTot);
        // if(data.EmStreams == "Y"){
        //   this.ExamForm.controls['EmStreams'].setValue('Y');
        // }
        // else if(data.EmStreams == 'N'){
        //   this.ExamForm.controls['EmStreams'].setValue('N')
        // }
        if (this.ExamForm.value['EmDiv'] == 'E') {
          this.ExamAggregateDisabled = true;
          this.ExamDivisionDisabled = false;
        } else if (this.ExamForm.value['EmDiv'] == 'A') {
          this.ExamAggregateDisabled = false;
          this.ExamDivisionDisabled = false;
        }
        else if (this.ExamForm.value['EmDiv'] == 'P') {
          this.ExamAggregateDisabled = false;
          this.ExamDivisionDisabled = false;
        } else if (this.ExamForm.value['EmDiv'] == 'W') {
          this.ExamAggregateDisabled = false;
          this.ExamDivisionDisabled = false;
        } else if (this.ExamForm.value['EmDiv'] == 'N'){
          this.ExamAggregateDisabled = true;
          this.ExamDivisionDisabled = true;
        }
        
       
        
        
      } else {
        this.spinner.hide();
        // this.umsService.openSnackbar(res.message);
        this.loadsettingspage();
      }
    });
  }

  delete(e, k) {
    if (e === 'true') {
      this.list = false;
    } else {
      this.list = true;
    }
  }

  getValue1(e) {
    const myArray = e[0].split(",");
    let count = 0;
    if (e == 0) {
      count = 0;
    }
    else if (myArray.length == 1) {
      count = 1;
    }
    else if (myArray.length == 2) {
      count = myArray.length;
    }
    else if (myArray.length == 3) {
      count = myArray.length;
    }
    this.marksGrid = this.ExamForm.get('marksGrid') as FormArray;
    this.marksGrid.clear();
    for (let index = 0; index < count; index++) {
      this.addnewMarks1(myArray[index]);
    }
  }

  addnewMarks1(e) {
    this.marksGrid = this.ExamForm.get('marksGrid') as FormArray;
    this.marksGrid.push(
      this.fb.group({
        FailInValue: new FormControl(e, [Validators.pattern('^[0-9]*$')])
      })
    );
    this.countofrowmarksGrid = this.marksGrid.length;
  }

  setValidor() {
    this.marksGrid = this.ExamForm.controls.marksGrid as FormArray;
    this.marksGrid.controls.forEach(element => {
      element.get('FailInValue').setValidators([Validators.required]);
      // element.controls('FailInValue').setValidators([Validators.required]);
      // this.marksGrid.controls['FailInValue'].setValidators([Validators.required]);
      // element.setValidators('FailInValue')
    })
  }

  removeValidator() {
    this.marksGrid = this.ExamForm.controls.marksGrid as FormArray;
    this.marksGrid.controls.forEach(element => {
      element.get('FailInValue').clearValidators();
    })
  }

  submit() {
    if (this.ExamForm.invalid) {
      this.ExamForm.get('EmCoCode').markAsTouched();
      this.ExamForm.get('EmCode').markAsTouched();
      this.ExamForm.get('EmName').markAsTouched();
      this.ExamForm.get('EmShName').markAsTouched();
      this.ExamForm.get('EmSubTot').markAsTouched();

      this.ExamForm.get('EmTotSub').markAsTouched();
      this.ExamForm.get('EmMaxTot').markAsTouched();
      this.ExamForm.get('EmVal').markAsTouched();
      this.ExamForm.get('EmValDev').markAsTouched();
      this.ExamForm.get('EmMarkList').markAsTouched();
      this.ExamForm.get('EmConv').markAsTouched();
      this.ExamForm.get('EmDivFirstMrk').markAsTouched();
      this.ExamForm.get('EmExmSuppl').markAsTouched();
      this.ExamForm.get('EmMarksD').markAsTouched();
      this.ExamForm.get('EmDebar').markAsTouched();
      this.ExamForm.get('EmDebarNo').markAsTouched();
      this.ExamForm.get('EmDebarType').markAsTouched();
      this.ExamForm.get('EmATKTSub').markAsTouched();
      this.ExamForm.get('EmCompart').markAsTouched();
      this.marksGrid = this.ExamForm.controls.marksGrid as FormArray;
      if (this.value != undefined || this.value == 'Marks' || this.value == 'Theory Practical' || this.value == 'Theory Practical Marks') {
        this.marksGrid.controls.forEach(element => {
          element.get('FailInValue').markAsTouched();
          this.setValidor();
        })
      }
      else {
        this.marksGrid.controls.forEach(element => {
          element.get('FailInValue').markAsUntouched();
        })
        this.removeValidator();
      }
      return;
    } else {
      this.Exam();
    }
  }

  Exam() {
    this.spinner.show();
    this.submitpayload = this.ExamForm.value;
    sessionStorage.setItem('EmName', this.submitpayload.EmName);
    sessionStorage.setItem('EmId', this.submitpayload.EmId);
    sessionStorage.setItem('EmCoCode', this.submitpayload.EmCoCode);
    sessionStorage.setItem('EmDiv', this.submitpayload.EmDiv);
    sessionStorage.setItem('EmElgblCd', this.submitpayload.EmElgblCd);
    sessionStorage.setItem('EmSubTot', this.submitpayload.EmSubTot);
    this.submitpayload.FailInValue = [];
    this.submitpayload.marksGrid.forEach(element => {
      this.submitpayload.FailInValue.push(parseInt(element['FailInValue']));
    });
    // let str = []
    // str.push(this.submitpayload.FailInValue.map(i => `${i.FailInValue}`).join(', '))
    // this.submitpayload.FailInValue = str;
    const result = [this.submitpayload.FailInValue.join(',')];
    this.submitpayload.FailInValue = result;
    if (this.submitpayload.EmElgblCd == 'NA') {
      this.submitpayload.FailInValue = [];
    }
    this.umsService.addExam(this.submitpayload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          let data = {};
          sessionStorage.setItem('EmId', res.EmId);
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          setTimeout(() => {
            this.getExamDataNoPrepoluationUpdate(this.submitpayload);
          }, 2000);
          // if (this.ExamForm.value['EmDiv'] == 'E') {
          //   this.ExamAggregateDisabled = true;
          //   this.ExamDivisionDisabled = false;
          // } else if (this.ExamForm.value['EmDiv'] == 'A') {
          //   this.ExamAggregateDisabled = false;
          //   this.ExamDivisionDisabled = false;
          // } else if (this.ExamForm.value['EmDiv'] == 'P') {
          //   this.ExamAggregateDisabled = false;
          //   this.ExamDivisionDisabled = false;
          // } else if (this.ExamForm.value['EmDiv'] == 'W') {
          //   this.ExamAggregateDisabled = false;
          //   this.ExamDivisionDisabled = false;
          // } else {
          //   this.ExamAggregateDisabled = true;
          //   this.ExamDivisionDisabled = true;
          // }
          this.loadExamList2(this.ExamForm.value);
          this.resetForm();
          this.SemesterDisabled = false
          this.DefGrd = false;
        } else {
          this.spinner.hide();
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.SemesterDisabled = true;
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        this.SemesterDisabled = true;
      }
    );
  }

  fetchMarklist() {
    const payload = {};
    payload['CdType'] = 'ML';
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.markList = res.data;
        this.filteredListOfMark = this.markList.slice();
      } else {
      }
    });
  }

  update() {
    if (this.ExamForm.invalid) {
      this.ExamForm.get('EmCoCode').markAsTouched();
      this.ExamForm.get('EmCode').markAsTouched();
      this.ExamForm.get('EmName').markAsTouched();
      this.ExamForm.get('EmShName').markAsTouched();
      this.ExamForm.get('EmSubTot').markAsTouched();

      this.ExamForm.get('EmTotSub').markAsTouched();
      this.ExamForm.get('EmMaxTot').markAsTouched();
      this.ExamForm.get('EmVal').markAsTouched();
      this.ExamForm.get('EmValDev').markAsTouched();
      this.ExamForm.get('EmMarkList').markAsTouched();
      this.ExamForm.get('EmConv').markAsTouched();
      this.ExamForm.get('EmDivFirstMrk').markAsTouched();
      this.ExamForm.get('EmExmSuppl').markAsTouched();
      this.ExamForm.get('EmMarksD').markAsTouched();
      this.ExamForm.get('EmDebar').markAsTouched();
      this.ExamForm.get('EmDebarNo').markAsTouched();
      this.ExamForm.get('EmDebarType').markAsTouched();
      this.ExamForm.get('EmATKTSub').markAsTouched();
      this.ExamForm.get('EmCompart').markAsTouched();
      this.marksGrid = this.ExamForm.controls.marksGrid as FormArray;
      if (this.value == 'Marks' || this.value == 'Theory Practical' || this.value == 'Theory Practical Marks') {
        this.marksGrid.controls.forEach(element => {
          this.setValidor();
          element.get('FailInValue').markAsTouched();
        })
      }
      else {
        this.marksGrid.controls.forEach(element => {
          element.get('FailInValue').markAsUntouched();
        })
        this.removeValidator();
      }
      return;
    } else {
      this.updateExam();
    }
  }

  updateExam() {
    this.spinner.show();
    this.submitpayload = this.ExamForm.value;
    sessionStorage.setItem('EmName', this.submitpayload.EmName);
    sessionStorage.setItem('EmId', this.submitpayload.EmId);
    sessionStorage.setItem('EmCoCode', this.submitpayload.EmCoCode);
    sessionStorage.setItem('EmDiv', this.submitpayload.EmDiv);
    sessionStorage.setItem('EmElgblCd', this.submitpayload.EmElgblCd);
    sessionStorage.setItem('EmSubTot', this.submitpayload.EmSubTot);
    this.submitpayload.FailInValue = [];
    this.submitpayload.marksGrid.forEach(element => {
      this.submitpayload.FailInValue.push(parseInt(element['FailInValue']));
    });
    const result = [this.submitpayload.FailInValue.join(',')];
    this.submitpayload.FailInValue = result;
    if (this.submitpayload.EmElgblCd == 'NA') {
      this.submitpayload.FailInValue = [];
    }
    this.umsService.updateExam(this.submitpayload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        let data = {};
        data['message'] = res.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        setTimeout(() => {
          this.getExamDataNoPrepoluationUpdate(this.submitpayload);
        }, 2000);
      } else {
        this.spinner.hide();
        let data = {};
        data['message'] = res.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(
          (result) => { },
        );
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      });
    if (this.ExamForm.value['EmDiv'] == 'E') {
      this.ExamAggregateDisabled = true;
      this.ExamDivisionDisabled = false;
    } else if (this.ExamForm.value['EmDiv'] == 'A') {
      this.ExamAggregateDisabled = false;
      this.ExamDivisionDisabled = false;
    } else if (this.ExamForm.value['EmDiv'] == 'P') {
      this.ExamAggregateDisabled = false;
      this.ExamDivisionDisabled = false;
    } else if (this.ExamForm.value['EmDiv'] == 'W') {
      this.ExamAggregateDisabled = false;
      this.ExamDivisionDisabled = false;
    } else {
      this.ExamAggregateDisabled = true;
      this.ExamDivisionDisabled = true;
    }

    if(this.ExamForm.value['EmEval'] == 'GPA'){
        this.DefGrd = true;
        this.DefGrdDisabled = false;
    }
    else{
      this.DefGrd = false;
    }
  }

  editdata(e, k) {
    if (e === 'true') {
      this.labelClick(k.EmCoCode);
      this.list = false;
      this.prepopulation(k);
      this.dropdowndisable = true;
      this.emCodeRead = true;
      this.deleteReadOnly = false;
      this.Read = false;
      this.emCodeRead =true;
    } else {
      this.list = true;
      this.loadsettingspage();
    }
  }

  selectExam(e, data) {


    if (e === 'true') {
      this.getExamDataNoPrepoluation2(data);
      this.labelClick(data.EmCoCode);
      this.list = false;
      this.getExamData(data);
      this.dropdowndisable = true;
      this.deleteReadOnly = false;
      this.Read = false;
      this.prepopulatedatapage(data);
    } else {
      this.list = true;
      this.loadsettingspage();
    }
  }

  selectExamNoPopulation(e, data) {
    if (e === 'true') {
      this.list = false;
      this.getExamDataNoPrepoluation(data);
      this.dropdowndisable = true;
      // this.prepopulatedatapage(course)
    } else {
      this.list = true;
      // this.loadsettingspage()
    }
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  openDialog(id) {
    let data = {};
    data['message'] = id.message;
    data['title'] = 'Information';
    data['icon'] = 'fas fa-trash';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
      AlertBoxComponent,
      data
    );
    this.dialogRef.afterClosed().subscribe((result) => { });
  }

  fetchSubTotal() {
    const payload = {};
    this.umsService.getSubTotal().subscribe((res) => {
      if (res.status) {
        this.subTotalList = res.data;
        this.filteredSubTotalList = this.subTotalList.slice();
      } else {
      }
    });
  }

  labelClick(value) {
    this.desLabel = '';
    this.filteredListCourse.forEach(element => {
      if (element['CoCode'] == value) {
        this.desLabel = element['CoName'];
      }
    });
    const payload = {};
    payload['CoCode'] = value;
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe((res) => {
      if (res.data.length == 0) {
        this.Read = true;
      } else {
        this.Read = false;
      }
    });

  }

  fetchCodeType(id) {
    const payload = {};
    payload['CdType'] = 'DV';
    payload['CdDesc'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.codeTypeList = res.data;
        this.filteredCodeType = this.codeTypeList.slice();
      } else {
      }
    });
  }

  onTabChanged(event: MatTabChangeEvent) {
    if (event.tab.textLabel == 'Exam Division') {
      this.ExamDivision.ngOnInit();
      // sessionStorage.reload();
    } else if (event.tab.textLabel == 'Exam Aggregate') {
      this.ExamAggregate.ngOnInit();
      // sessionStorage.reload();
    } else if (event.tab.textLabel == 'Semester') {
      this.Semester.ngOnInit();
      // sessionStorage.reload();
    } else if(event.tab.textLabel == 'DefineGrade'){
      this.DefineGrade.ngOnInit();
    }
  }

  deletee(e, k) {
    if (e === 'true') {
      this.labelClick(k.EmCoCode);
      this.list = false;
      // this.getExamAllData();
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }

  openConformationModalBox() {
    let data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result == 'yes') {
        this.deletedata(this.ExamForm.value);
      } else {
      }
    });
  }

  deletedata(id) {
    const payload = {};
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        EmId: id.EmId,
        EmCoCode: id.EmCoCode,
        EmSrNo: id.EmSrNo,
        EmCode: id.EmCode,
        EmName: id.EmName,
        EmShName: id.EmShName,
        EmStreams: id.EmStreams,
        EmClrSrNo: id.EmClrSrNo,
        EmATKTSub: id.EmATKTSub,
        EmElgblCd: id.EmElgblCd,
        EmLedger: id.EmLedger,
        EmMarkList: id.EmMarkList,
        EmLatEntry: id.EmLatEntry,
        EmRejImpr: id.EmRejImpr,
        EmEval: id.EmEval,
        EmTotSub: id.EmTotSub,
        EmMaxTot: id.EmMaxTot,
        // EmPassPC: id.EmPassPC,
        EmVal: id.EmVal,
        EmValDev: id.EmValDev,
        EmDiv: id.EmDiv,
        EmConv: id.EmConv,
        EmDivFirstAtt: id.EmDivFirstAtt,
        EmDivFirstMrk: id.EmDivFirstMrk,
        EmColg: id.EmColg,
        EmGrps: id.EmGrps,
        EmSubTot: id.EmSubTot,
        EmMinCr: id.EmMinCr,
        EmMaxCr: id.EmMaxCr,
        EmExmSuppl: id.EmExmSuppl,
        EmExmQ: id.EmExmQ,
        EmMarksD: id.EmMarksD,
        EmDebar: id.EmDebar,
        EmDebarNo: id.EmDebarNo,
        EmDebarType: id.EmDebarType,
        EmSpFlag: id.EmSpFlag,
      },
    };
    this.httpClient
      .delete(this.APIService + '/masters/exam', options)
      .subscribe(
        (s) => {
          let cc = [];
          cc.push(s);
          let data = {};
          data['message'] = cc[0].message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.dialogRef.afterClosed().subscribe((result) => {
            // this.ngOnInit();
            this.dialogRef1.close();
          });
        },
        (ERROR: HttpErrorResponse) => {
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Alert';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.ngOnInit();
          // this.dialogRef.close();
        }
      );
  }

  prepopulationForDelete(e) {
    this.SemesterDisabled = false;
    this.prepopulatedatapage(e);
    const payload = {};
    payload['EmCoCode'] = e.EmCoCode;
    payload['EmId'] = e.EmId;
    this.umsService.getExam(payload).subscribe((res) => {
      const data = res.data[0];
      let data1 = {};
      if (res.spRule.length == 1) {
        data1['SrNoMarks'] = res.spRule[0]['SrNoMarks'];
      } else {
        data1['SrNoMarks'] = 0;
      }
      if (res.status) {
        this.editButton = false;
        this.submitButton = false;
        this.deleteButton = true;
        this.resetButton = false;
        this.deleteReadOnly = true;
        this.Read = true;
        this.ReadOnly = false;
        this.emCodeRead = true;
        this.ReadOnlyCo = true;
        this.isDiv = true;
        let EmColg = false;
        if (data.EmColg == 1) {
          EmColg = true;
        } else {
          EmColg = false;
        }
        let EmGrps = false;
        if (data.EmGrps == 1) {
          EmGrps = true;
        } else {
          EmGrps = false;
        }
        let EmDivFirstAtt = false;
        let EmDivFirstMrk = false;
        if (data.EmDivFirstAtt == 1) {
          EmDivFirstAtt = true;
        } else {
          EmDivFirstAtt = false;
        }
        if (data.EmDivFirstMrk == 1) {
          EmDivFirstMrk = true;
        } else {
          EmDivFirstMrk = false;
        }
        let EmMarksD = false;
        if (data.EmMarksD == 1) {
          EmMarksD = true;
        } else {
          EmMarksD = false;
        }
        if(data.EmEval == 'GPA'){
          this.DefGrd = true;
          this.DefGrdDisabled = false;
        }
        else{
          this.DefGrd = false;
        }
        this.ExamForm = this.fb.group({
          EmId: new FormControl(data.EmId, [Validators.pattern('^[0-9]*$')]),
          EmCoCode: new FormControl(data.EmCoCode, [Validators.required,]),
          EmSrNo: new FormControl(data.EmSrNo, [Validators.pattern('^[0-9]*$'),]),
          EmCode: new FormControl(data.EmCode, [Validators.required, Validators.pattern("^[a-zA-z0-9- &\\s]*$"),]),
          EmName: new FormControl(data.EmName, [Validators.required]),
          EmCompart: new FormControl(data.EmSpFlag),
          EmShName: new FormControl(data.EmShName, [Validators.required]),
          EmStreams: new FormControl(data.EmStreams),
          EmClrSrNo: new FormControl(data.EmClrSrNo, [Validators.pattern('^[0-9]*$'),]),
          EmATKTSub: new FormControl(data.EmATKTSub, [Validators.pattern('^[0-9]*$'),]),
          EmElgblCd: new FormControl(data.EmElgblCd),
          EmLedger: new FormControl(data.EmLedger, [Validators.pattern('^[a-zA-Z0-9]*$'),]),
          EmMarkList: new FormControl(data.EmMarkList, [Validators.pattern('^[a-zA-Z0-9]*$'),]),
          EmLatEntry: new FormControl(data.EmLatEntry),
          EmRejImpr: new FormControl(data.EmRejImpr, [Validators.pattern('^[a-zA-Z0-9]*$'),]),
          EmEval: new FormControl(data.EmEval, [Validators.pattern('^[a-zA-Z0-9]*$'),]),
          EmTotSub: new FormControl(data.EmTotSub, [Validators.pattern('^[0-9]*$'),]),
          EmMaxTot: new FormControl(data.EmMaxTot, [Validators.pattern('^[0-9]*$'),]),
          // EmPassPC: new FormControl(data.EmPassPC, [Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]*)?))$'), Validators.max(100),]),
          EmVal: new FormControl(data.EmVal, [Validators.pattern('^[0-9]*$')]),
          EmValDev: new FormControl(data.EmValDev, [Validators.pattern('^[0-9]*$'),]),
          EmDiv: new FormControl(data.EmDiv),
          EmConv: new FormControl(data.EmConv),
          EmDivFirstAtt: new FormControl(EmDivFirstAtt),
          EmDivFirstMrk: new FormControl(EmDivFirstMrk),
          EmColg: new FormControl(EmColg),
          EmGrps: new FormControl(EmGrps),
          EmSpFlag: new FormControl(data.EmSpFlag),
          EmSubTot: new FormControl(data.EmSubTot),
          EmMinCr: new FormControl(data.EmMinCr, [Validators.pattern('^[0-9]*$'),]),
          EmMaxCr: new FormControl(data.EmMaxCr, [Validators.pattern('^[0-9]*$'),]),
          EmExmSuppl: new FormControl(data.EmExmSuppl),
          EmExmQ: new FormControl(data.EmExmQ, [Validators.pattern('^[a-zA-Z0-9]*$'),]),
          EmMarksD: new FormControl(EmMarksD),
          EmDebar: new FormControl(data.EmDebar),
          EmDebarNo: new FormControl(data.EmDebarNo, [Validators.pattern('^[0-9]*$'),]),
          EmDebarType: new FormControl(data.EmDebarType),
          FailInValue: new FormControl(data1['SrNoMarks']),
          marksGrid: new FormArray([]),
        });
        if (res.spRule.length == 1) {
          this.getValue1(data1['SrNoMarks'])
        }
        if (this.ExamForm.value['EmDiv'] == 'E') {
          this.ExamAggregateDisabled = true;
          this.ExamDivisionDisabled = false;
        } else if (this.ExamForm.value['EmDiv'] == 'A') {
          this.ExamAggregateDisabled = false;
          this.ExamDivisionDisabled = false;
        } else if (this.ExamForm.value['EmDiv'] == 'P') {
          this.ExamAggregateDisabled = false;
          this.ExamDivisionDisabled = false;
        } else if (this.ExamForm.value['EmDiv'] == 'W') {
          this.ExamAggregateDisabled = false;
          this.ExamDivisionDisabled = false;
        } else {
          this.ExamAggregateDisabled = true;
          this.ExamDivisionDisabled = true;
        }
        this.getExamDataNoPrepoluation2(e);
      } else {
        this.umsService.openSnackbar(res.message);
        this.loadsettingspage();
      }
    });
  }

  fetchElgbRule() {
    const payload = {};
    payload['CdType'] = 'ATKT';
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.elgbRuleList = res.data;
        this.filteredElgbRuleList = this.elgbRuleList.slice();
      }
    });
  }

  fetchUseSubTotal() {
    this.umsService.getSubFlag().subscribe((res) => {
      if (res.status) {
        this.subtotalList = res.data;
        this.filteredsubtotalList = this.subtotalList.slice();
      } else {
      }
    });
  }

  reset() {
    this.ExamForm.reset();
    window.location.reload();
  }

  public next() {
    this.selectedIndex += 1;
  }
  public prev() {
    this.selectedIndex -= 1;
  }

  condition(e) {
    let payload = this.ExamForm.value
    if (e >= payload.EmATKTSub) {
      this.ExamForm.value['EmTotSub'] = e;
    }
    else {
      this.ExamForm.get('EmTotSub').setErrors({
        'minIsGreaterThanMax': true
      })
    }
  }

  getclassRule() {
    this.umsService.getClass().subscribe((res) => {
      this.classRuleList = res.data;
      this.filteredListClass = this.classRuleList.slice();
    });
  }
  getEvaluation() {
    this.umsService.getEvaluation().subscribe((res) => {
      this.evaluationList = res.data;
      this.filteredListOfEmEval = this.evaluationList.slice();
    });
  }

  getValue(e) {
    this.value = e;
    this.marksGrid = this.ExamForm.get('marksGrid') as FormArray;
    this.marksGrid.clear();
    let count;
    if (this.value == 'Marks') {
      count = 1
    } else if (this.value == 'Theory Practical') {
      count = 2
    } else if (this.value == 'Theory Practical Marks') {
      count = 3
    } else if (this.value == 'Not Applicable') {
      // this.marksGrid.clear();
      count = 0
    }
    for (let index = 0; index < count; index++) {
      this.addnewMarks();
    }
  }

  addnewMarks() {
    this.marksGrid = this.ExamForm.get('marksGrid') as FormArray;
    this.marksGrid.push(
      this.fb.group({
        FailInValue: new FormControl('', [Validators.pattern('^[0-9]*$')])
      })
    );
    this.countofrowmarksGrid = this.marksGrid.length;
  }

  prepopulatedatapage(e) {
    this.spinner.show();
    let payload1 = {};
    payload1['FormPage'] = 'ExamData';
    // this.ExamForm.controls['StuId'].setValue(e.data[0]['StuId']);
    this.umsService.getStdSetting(payload1).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormControlName == 'EmCompart' && element.FormVisible == true) {
          this.RadioButn = true;
          this.Practical = false;
        }
        else if (element.FormControlName == 'EmCompart' && element.FormVisible == false) {
          this.RadioButn = false;
          // if (sessionStorage.getItem('Inst') == '6') {
          //   this.Practical = false;
          // } else {
          //   this.Practical = true;
          // }
        }
        if (element.FormName == 'Semester') {
          if (element.FormVisible) {
            // this.SemesterDisabled = false;
            this.SemTab = true;
          }
          else {
            // this.SemesterDisabled = true;
            this.SemTab = false;
          }
        }
        if(element.FormName == 'EmDiv'){
          if (element.FormVisible) {
            // this.SemesterDisabled = false;
            this.ExamAggregateTab = true;
          }
          else {
            // this.SemesterDisabled = true;
            this.ExamAggregateTab = false;
          }
        }
        if (element.FormVisible) {

          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.ExamForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));
            }
            else {
              this.ExamForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.ExamForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          }
        } else {
          this.ExamForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.mapdataaa(ress.data);
    });
  }

  loadsettingspage() {
    this.spinner.show();
    let payload2 = {};
    payload2['FormPage'] = 'ExamData';
    this.umsService.getStdSetting(payload2).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormControlName == 'EmCompart' && element.FormVisible == true) {
          this.RadioButn = true;
          this.Practical = false;
        }
        else if (element.FormControlName == 'EmCompart' && element.FormVisible == false) {
          this.RadioButn = false;
          this.Practical = true;
        }
        if (element.FormName == 'Semester') {
          if (element.FormVisible) {
            // this.SemesterDisabled = false;
            this.SemTab = true;
          }
          else {
            // this.SemesterDisabled = true;
            this.SemTab = false
          }
        }
        if(element.FormName == 'EmDiv'){
          if (element.FormVisible) {
            // this.SemesterDisabled = false;
            this.ExamAggregateTab = true;
          }
          else {
            // this.SemesterDisabled = true;
            this.ExamAggregateTab = false;
          }
        }
        if (element.FormVisible) {
          this[element.FormControlName + 'Boolean'] = element.FormVisible;
          if (element.FormRequired) {
            if (element.FormPattern == '') {

              this.ExamForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            }
            else {
              this.ExamForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.ExamForm.addControl(element.FormControlName, new FormControl(''));
          }
        } else {
          this[element.FormControlName + 'Boolean'] = element.FormVisible;
        }
      });
      this.mapdataaa(res.data);
    });
  }

  mapdataaa(e) {
    this.ExamFormArray = e.reduce(function (r, a) {
      r[a.FormControlName] = r[a.FormControlName] || [];
      r[a.FormControlName].push(a);
      return r;
    }, Object.create(null));
  }

  CompValue(e) {
    // Extract the existing input value (without the radio value) from 'EmCompart'
    let currentValue = this.ExamForm.value['EmCompart'];
    
    // If currentValue has more than one character, strip out the first character (radio value)
    if (currentValue && currentValue.length > 1) {
        currentValue = currentValue.substring(1); // Get the numeric part (e.g., '3')
    }

    // Join the new radio value (e.g., 'S' or 'P') with the input value (e.g., '3')
    let Compart = [e, currentValue].join("");
    
    this.ExamForm.controls['EmCompart'].setValue(Compart);

  }


  
}





